<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"  v-if="FormInputs">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group g-mb-0" v-show="FormInputs.OfficeLocationNumberOfJobs">
          <label>{{PledgeLabel}} <span v-bind:data-balloon="PledgeHelpText" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
        </div >
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="form-group" v-show="FormInputs.OfficeLocationNumberOfJobs">
          <input v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationNumberOfJobs }" type="number"
                 v-on:keypress="G_NumberCheck(this.event)"
                 v-on:keyup="G_NumberInputCheck(Account.PrimaryContact.OfficeLocation)"
                 v-model="Account.PrimaryContact.OfficeLocation.NumberOfJobs" class="form-control no-arrow-updown">
          <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationNumberOfJobs">{{OfficeLocationValidationResult.OfficeLocationNumberOfJobs}}</p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show="Account.PrimaryContact.OfficeLocation.NumberOfJobs >= 100">
        <p>Due to the high pledge/forecast, please break out your estimate by month across the remainder of the year.</p>
        <p><i><small>If there is a difference, your monthly total will replace your pledged number of orders</small></i></p>
        <div class="table-responsive">
          <table class="table table-bordered table-bg">
            <thead>
            <tr class="text-center">
              <th scope="col">Jan</th>
              <th scope="col">Feb</th>
              <th scope="col">Mar</th>
              <th scope="col">Apr</th>
              <th scope="col">May</th>
              <th scope="col">Jun</th>
            </tr>
            </thead>
            <tbody>

            <tr>
              <td><input ref="january_input" type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.January)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.January" v-bind:disabled="currentMonth > 1" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.February)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.February" v-bind:disabled="currentMonth > 2" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.March)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.March" v-bind:disabled="currentMonth > 3" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.April)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.April" v-bind:disabled="currentMonth > 4" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.May)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.May" v-bind:disabled="currentMonth > 5" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.June)" v-model="Account.PrimaryContact.OfficeLocation.Jobs.June" v-bind:disabled="currentMonth > 6" class="form-control pledge-input"></td>
            </tr>
            </tbody>
          </table>
          <table class="table table-bordered table-bg">
            <thead>
            <tr class="text-center">
              <th scope="col">Jul</th>
              <th scope="col">Aug</th>
              <th scope="col">Sep</th>
              <th scope="col">Oct</th>
              <th scope="col">Nov</th>
              <th scope="col">Dec</th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.July" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.July)" v-bind:disabled="currentMonth > 7" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.August" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.August)" v-bind:disabled="currentMonth > 8" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.September" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.September)" v-bind:disabled="currentMonth > 9" class="form-control  pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.October" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.October)" v-bind:disabled="currentMonth > 10" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.November"  v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.November)"  v-bind:disabled="currentMonth > 11" class="form-control pledge-input"></td>
              <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.December" v-on:keypress="G_NumberCheck(Account.PrimaryContact.OfficeLocation.Jobs.December)"  v-bind:disabled="currentMonth > 12" class="form-control pledge-input"></td>
            </tr>
            </tbody>
          </table>
          <div class="table-bg" style="border: 1px solid #ccc; padding: 10px; ">
            <p style="margin: 0; text-align: right"><b>Total: {{total}}</b></p>
          </div>
        </div>
        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationJobs">{{OfficeLocationValidationResult.OfficeLocationJobs}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [ 'Account', 'OfficeLocationValidationResult', 'FormInputs', 'PledgeLabel', 'PledgeHelpText' ],
    data() {
      return {
        total:0,
        currentMonth: 0,
      }
    },
    computed: {
      computedOfficeLocation() {
        return this.Account.PrimaryContact.OfficeLocation;
      },
      // pledge: function(){
      //   var text = null;
      //   if(this.type == "Individual"){
      //     text = "The participant pledges to place the following number of charitable orders this calendar year.*";
      //   }
      //   else if(this.type == "Business"){
      //     text = "This location of the business pledges/forecasts to place the following number of charitable orders this calendar year.*";
      //   }
      //   else if(this.type == "NonProfit"){
      //     text = "This location of the organization forecasts to place the following number of charitable orders this calendar year.*";
      //   }
      //   return text;
      // },
    },
    watch: {
      total(val) {
        if (val >= 100)
          this.computedOfficeLocation.NumberOfJobs = val;
      }
    },
    methods: {
      TotalJobs(){
        this.total = ((this.Account.PrimaryContact.OfficeLocation.Jobs.January ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.January) : 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.February ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.February): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.March ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.March): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.April ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.April): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.May ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.May): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.June ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.June): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.July ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.July): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.August ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.August): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.September ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.September): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.October ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.October): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.November ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.November): 0) +
          ((this.Account.PrimaryContact.OfficeLocation.Jobs.December ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.December): 0);
      },
    },
    created() {
      var dateTime = new Date();
      this.currentMonth = dateTime.getMonth() + 1;
    }
  }
</script>



// WEBPACK FOOTER //
// Pledge.vue?ea61f56e